import { render, staticRenderFns } from "./ButtonArrowSvg.vue?vue&type=template&id=07d4b234&"
import script from "./ButtonArrowSvg.vue?vue&type=script&lang=js&"
export * from "./ButtonArrowSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports